export const planets = ["PLUTO", "MARS", "VENUS", "NEPTUNE", "SATURN", "JUPITER"] as const;
export type Planet = (typeof planets)[number];

export const accountSize: Record<Planet, number> = {
  PLUTO: 5000,
  MARS: 10000,
  VENUS: 25000,
  NEPTUNE: 50000,
  SATURN: 100000,
  JUPITER: 200000,
};

export const ALL_PLANET_TYPES: Planet[] = [
  "PLUTO",
  "MARS",
  "VENUS",
  "NEPTUNE",
  "SATURN",
  "JUPITER",
];
